var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32351_89435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7984 25.2273L34.653 25.6468C34.5822 25.8501 34.5318 25.988 34.5225 26.0141C33.8289 27.8544 32.5872 29.3329 30.8327 30.4088C28.6941 31.7214 26.2535 32.1726 23.5816 31.7493C20.123 31.2012 17.5425 29.2789 15.9148 26.0365C14.3841 22.9918 14.1958 19.7271 15.3499 16.3318C15.6594 15.4201 16.0621 14.5885 16.5506 13.8352C16.5693 13.8166 16.586 13.798 16.6028 13.7812C16.8116 13.4568 17.0354 13.1491 17.2759 12.8545C17.3729 12.7352 17.4717 12.6177 17.5742 12.5059H9.92979C9.92979 12.5059 9.9242 12.5189 9.9186 12.5245H2.00195L2.96403 15.0621C3.79746 17.2603 5.90248 18.7146 8.25174 18.7184C8.25174 18.7314 8.31141 18.7351 8.38972 18.7333C8.21632 20.6201 8.33564 22.5611 8.74397 24.5393C9.52892 28.3261 11.4494 31.5237 14.4531 34.0427C16.1833 35.4932 18.1373 36.5504 20.2591 37.1862C21.9316 37.6859 23.6525 37.9357 25.4088 37.9357C26.7569 37.9357 28.1291 37.7884 29.5107 37.4939C33.9408 36.5485 37.2148 34.0445 39.5193 29.842L39.6294 29.6406L34.7947 25.2292L34.7984 25.2273Z",
    fill: "#282828"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.91387 8.78063H25.0324C26.6116 8.78063 28.23 9.14608 29.841 9.86391C31.9982 10.8241 33.5196 12.4164 34.3642 14.5941L39.0646 10.261C37.7893 8.20637 36.074 6.56747 33.954 5.38725C32.0187 4.30957 29.8484 3.63835 27.3183 3.33817C27.0237 3.30274 26.1642 3.2207 24.5104 3.2207H0.527344L1.32535 5.32572C2.05996 7.2648 3.86852 8.62029 5.91387 8.7825",
    fill: "#282828"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32351_89435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.6744,
    height: 39.6744,
    fill: "white",
    transform: "translate(0.527344 0.741211)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaIcon);
export default __webpack_public_path__ + "static/media/CA-Icon.ee305c0cba58941dada39f51c28030ab.svg";
export { ForwardRef as ReactComponent };